import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import { brandColors } from 'styles/colors';

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: hidden;
	padding: 0 0 2% 0;
	margin: -3% 0 0 0;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: start;
	width: 98%;
	gap: 1.5%;
`;

export const InsightsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const TutorialWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const TitleWrapper = styled.div`
	text-align: center;
	padding: 2% 0;
`;

export const Heading = styled.div`
	font-size: 1.75rem;
	line-height: 2.3rem;
	font-weight: 700;
	color: ${colors.grey5};
`;

export const MapBackgroundWrapper = styled.div`
	background-color: ${colors.grey2};
	border-radius: 10px;
	position: relative;
	display: flex; /* Flexbox layout */
	flex-wrap: wrap;
	justify-content: space-around;
	height: 63vh;
	${({ imageUrl }) => imageUrl && `background-image: url(${imageUrl})`};
	background-repeat: no-repeat;
	background-position: -3em 4em;
	background-size: 109% 100%;
	overflow: hidden;
`;

export const TutrialBackgroundWrapper = styled.div`
  background: ${colors.white}
  border-radius: 10px;
  overflow: hidden
`;

export const KPIValue = styled.h5`
	font-size: clamp(1.2rem, 2vw, 2.2rem);
	margin: 0;
	font-weight: 900;
	line-height: 34px;
	text-align: center;
	color: ${brandColors.green};

	@media (max-width: 1366px) {
		font-size: 1.5em;
	}
`;

export const KPIText = styled.h4`
	text-align: center;
	margin: 0;
	font-size: clamp(0.5rem, 0.8vw, 0.7rem);
	font-weight: 600;
	color: ${colors.grey6};
	line-height: 18px;
	text-transform: uppercase;
`;

export const KPIText2 = styled.h4`
	font-size: 1.8em;
	font-weight: 800;
	color: #5cb335;
	text-transform: uppercase;
`;
// color: #515050;

export const TutorialSection = styled.div`
	height: 63vh;
	overflow: hidden;

	@media (max-width: 1440px) {
		height: 58vh;
	}

	@media (max-width: 1366px) {
		height: 63vh;
	}
`;

export const TextOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
`;

export const HexagonNumber = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;
	align-items: center;
	&.hexagon-1 {
		top: 39%;
		left: 8%;
		transform: translate(-50%, -50%);
	}
	&.hexagon-2 {
		top: 53.4vh;
		left: 26vh;
		transform: translate(-50%, -50%);
	}

	&.hexagon-3 {
		top: 39.4%;
		left: 46%;
		transform: translate(-50%, -50%);
	}

	&.hexagon-4 {
		top: 74.4%;
		left: 64%;
		transform: translate(-50%, -50%);
	}

	&.hexagon-5 {
		top: 19.4%;
		left: 76%;
		transform: translate(-50%, -50%);
	}

	&.hexagon-6 {
		top: 32.4%;
		left: 93%;
		transform: translate(-50%, -50%);
	}
`;

export const HexagonGrid = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: grid;
	grid-template-columns: repeat(5, 1fr); /* 5 columns instead of 3 */
	grid-template-rows: repeat(4, 1fr); /* 4 rows instead of 2 */
	width: 100%;
	height: 100%;
`;
